import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const ProductStock = (props) => {
  const { className, children } = props;
  return (
    <div className={cn('c-product-stock', className)}>
      <div className={cn('u-clearfix')}>{children}</div>
    </div>
  );
};

export default ProductStock;

ProductStock.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
};

ProductStock.defaultProps = {
  className: '',
};
